import { jsx as _jsx } from "react/jsx-runtime";
import { Routes } from '../../../const';
import { useMainContext } from '../../../context';
import usePaymentOptions from '../../../hooks/use-payment-options';
import useFeatureFlags from '../../../hooks/use-feature-flags';
import { Questionnaire } from '../../../ui/Questionnaire';
import Confirm from '../../../ui/Questionnaire/Confirm';
import Contact from '../../../ui/Settlement/Contact';
import Options from '../../../ui/Settlement/Options';
import Review from '../../../ui/Settlement/Review';
import Start from '../../../ui/Settlement/Start';
import Success from '../../../ui/Settlement/Success';
import Error from '../../../ui/common/Error';
import Forbearance from '../../../ui/CustomerAssistancePlan/Forbearance';
import { PaymentOptions } from '../PaymentOptions';
export var RenderBody = function (_a) {
    var isModalReady = _a.isModalReady, navigateTo = _a.navigateTo, plan = _a.plan, settlement = _a.settlement;
    var _b = useMainContext(), currentRoute = _b.currentRoute, autopayStatus = _b.autopayStatus;
    var paymentOptions = usePaymentOptions(settlement, plan, navigateTo);
    var paymentOptionsLoading = [settlement.isLoading, plan.isLoading].some(Boolean);
    var showForbearancePage = useFeatureFlags().showForbearancePage;
    switch (currentRoute) {
        case Routes.SETTLEMENT_START:
        case Routes.PLAN_START:
            return _jsx(Start, {});
        case Routes.SETTLEMENT_QUESTIONNAIRE:
            return (_jsx(Questionnaire, { settlement: settlement, currentRoute: currentRoute }));
        case Routes.PLAN_QUESTIONNAIRE:
            return _jsx(Questionnaire, { plan: plan, currentRoute: currentRoute });
        case Routes.SETTLEMENT_OPTIONS:
            return _jsx(Options, { settlement: settlement });
        case Routes.SETTLEMENT_REVIEW:
            return _jsx(Review, { settlement: settlement });
        case Routes.PLAN_REVIEW:
            return _jsx(Review, { plan: plan });
        case Routes.PLAN_CONFIRM:
            return _jsx(Confirm, {});
        case Routes.PLAN_FORBEARANCE: {
            if (!showForbearancePage) {
                return (_jsx(PaymentOptions, { isLoading: paymentOptionsLoading || !isModalReady, paymentOptions: paymentOptions }));
            }
            return _jsx(Forbearance, {});
        }
        case Routes.SETTLEMENT_SUCCESS:
            return (_jsx(Success, { settlement: settlement, navigateTo: navigateTo, isModalReady: isModalReady }));
        case Routes.PLAN_SUCCESS:
            return (_jsx(Success, { plan: plan, navigateTo: navigateTo, autoPayStatus: autopayStatus, isModalReady: isModalReady }));
        case Routes.SETTLEMENT_CONTACT:
        case Routes.PLAN_CONTACT:
            return _jsx(Contact, {});
        case Routes.SETTLEMENT_ERROR:
        case Routes.PLAN_ERROR:
            return _jsx(Error, { currentRoute: currentRoute });
        default:
            return (_jsx(PaymentOptions, { isLoading: paymentOptionsLoading || !isModalReady, paymentOptions: paymentOptions }));
    }
};
//# sourceMappingURL=index.js.map